"use strict";
var Observable_1 = require('../../Observable');
var concat_1 = require('../../observable/concat');
Observable_1.Observable.concat = concat_1.concat;
//# sourceMappingURL=concat.js.map


/*****************
 ** WEBPACK FOOTER
 ** F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/~/rxjs/add/observable/concat.js
 ** module id = 70
 ** module chunks = 2
 **/